export enum PreviewOptionName {
  DESKTOP = 'Desktop',
  IPAD = 'iPad',
  MOBILE = 'Mobile',
}

export const VEEVA_CRM_EMAIL_HTML_LIMIT = 131072;
